import { doGet } from '../http/httpHelper';

export const getQuestions = (productId) => {
    return doGet(`/questions?productId=${productId}`);
};
